import * as React from 'react';
import {observer} from "@legendapp/state/react";
import {$viewingAttendanceId} from "_pages/service/queue/state";
import {useAttendance} from "_api/hooks/attendances";
import {HStack, VStack} from "_ui/Box";
import {BackButton, Button} from "_ui/Button";
import {useGoBack} from "_utils/url";
import {$keepFilters} from "_pages/service/queue/components/table/Filters";
import {Divider} from "@mui/material";
import {TimeDiff} from "_pages/service/queue/components/top-bar/TimeDiff";
import { Spinner } from 'react-bootstrap';

export const ViewInfo = observer(() => {
    const attendanceId = $viewingAttendanceId.get();
    const {attendance} = useAttendance(attendanceId!);
    const back = useGoBack();

    const onBack = () => {
        $viewingAttendanceId.set(undefined);
        $keepFilters.set(true);
        back();
    }

    return (
        <HStack g={2} alignCenter center wrap>
            <span>{attendance.clientServed.name}</span>
            <Divider orientation='vertical' flexItem/>
            <BackButton onClick={onBack}/>
        </HStack>
    );
});
